// NOTE: this function generates a constant function. i.e. a function that will always return the same value

const K = (value) => () => value;

export default K;
